import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import { Map } from 'immutable';
export default function ImageWithPreview(props) {
  const { filename, ...imgProps } = props;
  const [state, setState] = React.useState(Map({ previewOpened: false }));

  const handleClose = React.useCallback(() => {
    setState(oldState => oldState.set('previewOpened', false));
  }, []);
  const onPreview = React.useCallback(() => {
    setState(oldState => oldState.set('previewOpened', true));
  }, []);
  return (
    <>
      <Dialog open={state.get('previewOpened')} onClose={handleClose}>
        <img src={imgProps.src} style={{ objectFit: 'contain', height: 500 }} />
      </Dialog>
      <img
        {...imgProps}
        onClick={onPreview}
        style={{ cursor: 'pointer', objectFit: 'contain' }}
      />
    </>
  );
}
